<script lang="ts">
import { UiIds } from '../helpers/ui-ids';

  import { ariaDescribes } from './aria-describes';
  export let ariaDescribesId: string;
  const id = UiIds.create();
</script>

<div class="form-text" {id} use:ariaDescribes={ariaDescribesId}>
  <slot></slot>
</div>

<style lang="scss">
 	@import '../../../node_modules/bootstrap/scss/functions';
    @import '../../../node_modules/bootstrap/scss/mixins';
    @import '../../../node_modules/bootstrap/scss/variables';
   .form-text {
     font-size: $font-size-sm;
     color: $text-muted;
   }
</style>
